<template>
  <div>
    <InstrumentQueueDashboard />
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

const InstrumentQueueDashboard = defineAsyncComponent(() =>
  import("@/components/instrumentQueue/InstrumentQueueDashboard")
);

export default {
  name: "InstrumentQueueView",
  components: {
    InstrumentQueueDashboard,
  },
};
</script>
